export default (value: any): number => (typeof value === 'number' ? value : -1);
